"use client";
import type { Route } from "next";
import Link from "next/link";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";

export default function ListItem({
  title,
  children,
  href,
  ...props
}: React.ComponentPropsWithoutRef<"li"> & { href: string }) {
  return (
    <li {...props}>
      <NavigationMenuLink asChild>
        <Link
          className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
          href={href as Route}
        >
          <div className="font-bold text-sm leading-none">{title}</div>
          <p className="body-text-small line-clamp-2 text-muted-foreground leading-snug">
            {children}
          </p>
        </Link>
      </NavigationMenuLink>
    </li>
  );
}
